





import Vue from 'vue';
import { Partner } from '@/modules/kartoteka/partner';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'PojistovnaSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_POJISTOVNA_SELECT_MAPPER}`,
			};
		},
		actionsMappers(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.POJISTOVNA_CHANGE}`,
			};
		},
	},
});
